module.exports = __webpack_public_path__ + "img/sleeve ruffle width.913ddd24.png";